import React, { useState } from "react";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import {
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import CountryList from "../Shared/CountryList";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const License = ({ handleCloseLicense }) => {
  const navigate = useNavigate();
  const user = secureLocalStorage.getItem("user-info");
   const agentId = user?.uid;
  const [isLoading, setIsLoading] = useState(false);
  const [formState, setFormState] = useState({
    agentId,
    fullname: "",
    nationality: "",
    phone: "",
    email: "",
    passportCopy: null,
    iqamaCopy: null,
    drivingLicense: null,
    photo: null,
    termsAccepted: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;

    setFormState({
      ...formState,
      [name]: files[0],
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const url = "https://api.flyjatt.com/v1/License/index.php?add";
    const formData = new FormData();
    formData.append("agentId", formState?.agentId);
    formData.append("fullname", formState?.fullname);
    formData.append("nationality", formState?.nationality);
    formData.append("phone", formState?.phone);
    formData.append("email", formState?.email);
    formData.append("passportimg", formState?.passportCopy);
    formData.append("iqamaimg", formState?.iqamaCopy);
    formData.append("drivinglicenseimg", formState?.drivingLicense);
    formData.append("passportsizephoto", formState?.photo);
    const config = {
      method: "POST",
      body: formData,
    };
    fetch(url, config)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.status?.toLowerCase() === "success") {
          handleCloseLicense();
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            title: "License added Successfully",
            confirmationButtonText: "ok",
          }).then(() => {
            navigate(0);
          });
        } else {
          throw new Error();
        }
      })
      .catch((error) => {
        console.error(error);
        handleCloseLicense();
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Failed To Add",
          confirmationButtonText: "Try Again",
        }).then(() => {
          navigate(0);
        });
      });
    console.log(formState);
  };
  return (
    <Box
      sx={{
        label: {
          color: "var(--secondary-color)",
          fontWeight: "500",
          fontSize: { xs: 12, sm: 14 },
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
            fontSize: { xs: "20px", sm: "24px" },
            fontWeight: "500",
            color: "black",
          }}
        >
          International Driving License Application
        </Typography>
        <Grid container spacing={1} sx={{ mt: "10px" }}>
          <Grid item md={8} sm={12} xs={12}>
            <label htmlFor="fullname">Full Name</label>
            <Box sx={{ position: "relative" }}>
              <input
                placeholder="Enter Your Full Name"
                name="fullname"
                type="text"
                id="fullname"
                onChange={handleChange}
                style={{
                  height: "40px",
                  width: "100%",
                  outline: "none",
                  border: "none",
                  borderRadius: "4px",
                  padding: "0px 10px",
                  color: "var(--secondary-color)",
                  background: "white",
                  fontSize: "16px",
                }}
              />
              <PermIdentityOutlinedIcon
                sx={{
                  color: "var(--primary-color)",
                  position: "absolute",
                  top: "50%",
                  right: "5px",
                  transform: "translate(-5px,-50%)",
                }}
              />
            </Box>
          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <label htmlFor="nationality">Select Nationality</label>
            <select
              required
              name="nationality"
              id="nationality"
              onChange={handleChange}
              style={{
                height: "40px",
                width: "100%",
                outline: "none",
                border: "none",
                borderRadius: "4px",
                padding: "0px 10px",
                color: "var(--secondary-color)",
                background: "white",
                fontSize: "16px",
              }}
            >
              <option value="">Select Nationality</option>
              {CountryList.map((country, index) => {
                return (
                  <option key={index} value={country.code}>
                    {country.name}
                  </option>
                );
              })}
            </select>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <label htmlFor="phone">Contact No</label>
            <Box sx={{ position: "relative" }}>
              <input
                required
                name="phone"
                id="phone"
                placeholder="Enter Phone Number"
                onChange={handleChange}
                style={{
                  height: "40px",
                  width: "100%",
                  outline: "none",
                  border: "none",
                  borderRadius: "4px",
                  padding: "0px 10px",
                  color: "var(--secondary-color)",
                  background: "white",
                  fontSize: "16px",
                }}
              />
              <CallOutlinedIcon
                sx={{
                  color: "var(--primary-color)",
                  position: "absolute",
                  top: "50%",
                  right: "5px",
                  transform: "translate(-5px,-50%)",
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <label htmlFor="email">Email</label>
            <Box sx={{ position: "relative" }}>
              <input
                required
                type="email"
                name="email"
                id="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                placeholder="Enter Email ID"
                onChange={handleChange}
                style={{
                  height: "40px",
                  width: "100%",
                  outline: "none",
                  border: "none",
                  borderRadius: "4px",
                  padding: "0px 10px",
                  color: "var(--secondary-color)",
                  background: "white",
                  fontSize: "16px",
                }}
              />
              <EmailOutlinedIcon
                sx={{
                  color: "var(--primary-color)",
                  position: "absolute",
                  top: "50%",
                  right: "5px",
                  transform: "translate(-5px,-50%)",
                }}
              />
            </Box>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            {/* //todo: passport copy */}
            <label>Passport Copy</label>
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                type="file"
                name="passportCopy"
                id="passportCopy"
                onChange={handleFileChange}
                style={{
                  opacity: 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              />
              <label
                htmlFor="passportCopy"
                style={{
                  display: "inline-block",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    width: "100%",
                    height: "100%",
                    border: "2px dashed var(--secondary-color)",
                    px: "10px",

                    borderRadius: "4px",
                    fontSize: { xs: 12, sm: 14 },
                    overflow: "hidden",
                  }}
                >
                  <FileUploadOutlinedIcon
                    fontSize="large"
                    sx={{ mr: 1, color: "var(--primary-color)" }}
                  />
                  {formState?.passportCopy ? (
                    <span>{formState?.passportCopy?.name}</span>
                  ) : (
                    <span style={{ color: "gray" }}>Upload Passport Copy</span>
                  )}
                </Box>
              </label>
            </Box>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            {/* //todo: Iqama copy */}
            <label>Iqama Copy</label>
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                type="file"
                name="iqamaCopy"
                id="iqamaCopy"
                onChange={handleFileChange}
                style={{
                  opacity: 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              />
              <label
                htmlFor="iqamaCopy"
                style={{
                  display: "inline-block",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    width: "100%",
                    height: "100%",
                    border: "2px dashed var(--secondary-color)",
                    paddingLeft: "10px",
                    paddingRight: { xs: "20px", sm: 0 },
                    borderRadius: "4px",
                    fontSize: { xs: 12, sm: 14 },
                    overflow: "hidden",
                  }}
                >
                  <FileUploadOutlinedIcon
                    fontSize="large"
                    sx={{ mr: 1, color: "var(--primary-color)" }}
                  />
                  {formState?.iqamaCopy ? (
                    <span>{formState?.iqamaCopy?.name}</span>
                  ) : (
                    <span style={{ color: "gray" }}>Upload Iqama Copy</span>
                  )}
                </Box>
              </label>
            </Box>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            {/* //todo saudi Driving License */}
            <label>Saudi Driving License</label>
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                type="file"
                name="drivingLicense"
                id="photo"
                onChange={handleFileChange}
                style={{
                  opacity: 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              />
              <label
                htmlFor="drivingLicense"
                style={{
                  display: "inline-block",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    width: "100%",
                    height: "100%",
                    border: "2px dashed var(--secondary-color)",
                    padding: "0px 10px",
                    borderRadius: "4px",
                    fontSize: { xs: 12, sm: 14 },
                    overflow: "hidden",
                  }}
                >
                  <FileUploadOutlinedIcon
                    fontSize="large"
                    sx={{ mr: 1, color: "var(--primary-color)" }}
                  />
                  {formState?.drivingLicense ? (
                    <span>{formState?.drivingLicense?.name}</span>
                  ) : (
                    <span style={{ color: "gray" }}>
                      Upload Saudi Driving License
                    </span>
                  )}
                </Box>
              </label>
            </Box>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            {/* //todo:passport size photo */}
            <label>Passport Size Photo</label>
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                type="file"
                name="photo"
                id="photo"
                onChange={handleFileChange}
                style={{
                  opacity: 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              />
              <label
                htmlFor="photo"
                style={{
                  display: "inline-block",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    width: "100%",
                    height: "100%",
                    border: "2px dashed var(--secondary-color)",
                    padding: "0px 10px",
                    borderRadius: "4px",
                    fontSize: { xs: 12, sm: 14 },
                    overflow: "hidden",
                  }}
                >
                  <FileUploadOutlinedIcon
                    fontSize="large"
                    sx={{ mr: 1, color: "var(--primary-color)" }}
                  />
                  {formState?.photo ? (
                    <span>{formState?.photo?.name}</span>
                  ) : (
                    <span style={{ color: "gray" }}>
                      Upload Passport Size Photo
                    </span>
                  )}
                </Box>
              </label>
            </Box>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="termsAccepted"
                  checked={formState.termsAccepted}
                  onChange={handleChange}
                />
              }
              label="I agree to the terms and conditions"
            />
          </Grid>
          <Box sx={{ width: "100%", textAlign: "right" }}>
            <Button
              disabled={isLoading}
              type="submit"
              variant="contained"
              sx={{ width: { xs: "100%", sm: "" } }}
              style={{ color: "white", background: "var(--primary-color)" }}
            >
              {isLoading ? "Processing" : "Submit"}
            </Button>
          </Box>
        </Grid>
      </form>
    </Box>
  );
};

export default License;
